import React, { FC } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Button } from '@components/Button'
import { MinusSignIcon } from '@components/Icons'
import { FaqItemType } from './FaqSection'
import {
  FaqDescriptionWrapper,
  CollapseBtnWrapper,
  collapseBtnStyles,
} from './FaqDescription.elements'

type Props = {
  faq: FaqItemType
  onToggle: () => void
  isOpen: boolean
}

export const FaqDescription: FC<Props> = ({ faq, onToggle, isOpen }) => (
  <FaqDescriptionWrapper>
    {faq.text}
    <CollapseBtnWrapper>
      <Button
        onClick={onToggle}
        variant="text"
        tabIndex={isOpen ? 0 : -1}
        css={collapseBtnStyles}
      >
        Collapse
        <MinusSignIcon />
      </Button>
    </CollapseBtnWrapper>
  </FaqDescriptionWrapper>
)
